
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, watch, } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Collapse from '@/components/paragraphColl.vue'
import Nodata from '@/components/page/nodata.vue'
import f10ApiUS from '@/api/f10ApiUS'
import { isLocalDev } from '@/api/config'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
  },
  components: { Collapse, Nodata },

  setup(props, context) {
    const pageData: any = reactive({
      spinning: true,
      str: ''
    })
    onMounted(() => {


      // data.data = {
      //   market: 'HK' || route.query.market,
      //   symbol: '00700' || route.query.symbol,
      //   mangeType: '1',
      //   mangeYear:'1'
      // }
      // data.headers = {
      //   token: '3d5eff0d3c7ac7f3af30c337dcdf6944' || props.token
      // }

      // f10ApiHk.getBriefBriefManagement(data).then((res: any) => {
      //   console.log('我是主营介绍', res.data)

      // })


      const route: any = useRoute()
      const market = isLocalDev ? 'NASDAQ' : (route.query.market as string)
      const symbol = isLocalDev ? 'AAPL' : (route.query.code as string)

      const data = {
        data: {
          market,
          symbol,
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }

      f10ApiUS.getXxqk(data).then((res: any) => {
        if (res) {
          pageData.str = res.data?.mainOperationBusiness
          pageData.spinning = false
        }

      })

    })
    // watch(
    //   () => (props.pageSourceData || {}).BusinessProfile,
    //   (val: any) => {
    //     pageData.str = val
    //     nextTick(() => {
    //       pageData.spinning = false
    //     })
    //   },
    //   { deep: true }
    // )
    return {
      ...toRefs(pageData)
    }
  }
})
